import * as React from 'react';

import GlobalLoadingContext from './context';

/**
 * The GlobalLoader component.
 *
 * Displays the single loader for th entire app
 */

const GlobalLoader: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const context = React.useContext(GlobalLoadingContext);
  const { setGlobalLoading } = context;
  React.useEffect(() => {
    setGlobalLoading(true);
    return () => {
      setGlobalLoading(false);
    };
  }, [setGlobalLoading]);
  return <>{children}</>;
};

export default GlobalLoader;
